import axios from 'axios';
import { useEffect, useState } from 'react';
import { Redirect } from 'react-router';

export default function SignOut() {
    const [isPending, setIsPending] = useState(true);

    const [isSCG, setIsSCG] = useState<boolean>();

    // Fetch isSCG first
    useEffect(() => {
        fetchIsSCGAsync();
    }, []);

    useEffect(() => {
        if (isSCG === undefined || isSCG === null) return;

        //const logoutUrls = isSCG
        //    ? ['https://scg-wf.sonarinno.com/logout', 'https://scg-dms.sonarinno.com/logout']
        //    : ['https://wf.thailanderp.com/logout', 'https://dms.thailanderp.com/logout'];

        if (isSCG) {
            const logoutUrls = ['https://scg-wf.sonarinno.com/logout', 'https://scg-dms.sonarinno.com/logout'];

            const windows = logoutUrls.map(url => window.open(url, '', 'width=,height=,resizable=no'));

            setTimeout(() => {
                windows.forEach(win => win?.close());
            }, 2000);
        }

        setTimeout(() => {
            setIsPending(false);
        }, isSCG ? 5000 : 1000);

        setTimeout(() => {
            const mode = getMode();
            if (mode == 'gui') {
                var jResGui = {
                    action: 'WEB_LOGOUT',
                    //token: ,
                    //citizen_id: citizenId,
                    //select_server: {
                    //    system_type: 'GUI',
                    //    system_id: dataItem.application_sid,
                    //    system_name: dataItem.application_name.replace('\n', ' '),
                    //    host: dataItem.application_host,
                    //    port: dataItem.application_port
                    //}
                };

                var res = JSON.stringify(jResGui);

                (window as any).chrome.webview.postMessage(res);
            }
        }, isSCG ? 6000 : 2000);
    }, [isSCG]);

    const fetchIsSCGAsync = async () => {
        try {
            const response = await axios.get('/v1/link-sid');
            const data = response.data;

            setIsSCG(data.link_sid === 'SCG');
        } catch (error) {
            setIsSCG(false);
        }
    };

    const getMode = () => {
        return localStorage.getItem('mode') ?? '';
    }

    if (!isPending) {
        localStorage.removeItem('SSO_AUTH');

        return <Redirect to="/login" />;
    }

    return (
        <div>
            <h2 style={{ textAlign: 'center' }}>Signing Out...</h2>
        </div>
    );
}
